import moment from 'moment-timezone'
export default {
  methods: {
    momentFormat (value, arg) {
      const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      return moment(value).tz(clientTimezone).format(arg);
    },
    momentFormatWithoutUtc (value, arg) {
      const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      return moment(value).tz(clientTimezone).format(arg)
    },
    momentTimestampFormat (value, arg) {
      return moment(new Date(value)).format(arg)
    },
    momentConvertToUTCAndReturn(value, arg){
      const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      return moment(new Date(moment.utc(value).format())).tz(clientTimezone).format(arg)
    },
    momentConvertToUK(value, arg) {
      const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      return moment.utc(value).tz(clientTimezone).format(arg);
    },
    momentConvertToUKTime(value, arg) {
      return moment.tz(value, 'Europe/London').format(arg)
    },
    replaceNextDayDeliveryToMonday (delivery_types) {
      return delivery_types
      const today = moment().format('dddd')
      if (today !== 'Friday' && today !== 'Saturday' && today !== 'Sunday') return delivery_types
      delivery_types.forEach((single_delivery_type, index) => {
        let name = single_delivery_type.name
        if (name.includes('Next Day') && !name.includes('Standard')) {
          if (delivery_types[index].is_cold_chain) delivery_types[index].name = delivery_types[index].name.replace('Next Day', 'Next Day (Tuesday)')
          else delivery_types[index].name = delivery_types[index].name.replace('Next Day', 'Next Day (Monday)')
        }
      })
      return delivery_types
    }
  },
  filters: {
    momentFormat (value, arg) {
      return moment(value).format(arg)
    },
    momentTimestampFormat (value, arg) {
      return moment(new Date(value)).format(arg)
    }
  }
}
